import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "v-errors" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "message" }
const _hoisted_6 = {
  key: 0,
  class: "is_deleted"
}
const _hoisted_7 = {
  key: 1,
  class: "reply__time"
}
const _hoisted_8 = {
  key: 2,
  class: "is_edited"
}
const _hoisted_9 = { key: 3 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 4 }
const _hoisted_12 = {
  key: 5,
  class: "message__document"
}
const _hoisted_13 = { key: 6 }
const _hoisted_14 = { key: 7 }
const _hoisted_15 = {
  key: 9,
  class: "text"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "history" }
const _hoisted_18 = { class: "history__item--date" }
const _hoisted_19 = {
  class: "history__item--message",
  lang: "en"
}
const _hoisted_20 = { class: "modal__footer" }

import CommonFilter from '@/components/common/CommonFilter.vue';
import ErrorPanel from "@/features/errors/ui/errorPanel.vue";
import {useErrorStore} from "@/features/errors/errors.store";
import {ref, watch} from "vue";
import {IChat, IChatItem} from "@/features/chat/chat.types";
import {IPaginationMeta} from "@/features/pagination/pagination.types";
import {DateTime} from "luxon";
import {ISavedMessage} from "@/features/saved/saved.types";
import {useSavedMessagesStore} from "@/features/saved/saved.store";
import {useAlert} from "@/utils/alert";
import {useAppStore} from "@/store/app.store";
import WidgetPanels from "@/components/widget/WidgetPanels.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import {ArrowNarrowDownLeft, ArrowNarrowUpRight, Bookmark, Clock, Edit02, Image01, Trash01} from "utruckin-icons";
import VideoMessage from "@/features/message/ui/videoMessage.vue";
import EditedMessage from "@/features/message/ui/editedMessage.vue";
import DocumentMessage from "@/features/message/ui/documentMessage.vue";
import ReplyTime from "@/features/message/ui/replyTime.vue";
import CallMessage from "@/features/message/ui/callMessage.vue";
import VoiceMessage from "@/features/message/ui/voiceMessage.vue";
import CommonPagination from "@/components/common/CommonPagination.vue";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import {IMessageHistory} from "@/types/main";


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorsView',
  setup(__props) {

const errorStore = useErrorStore();
const appStore = useAppStore();
const savedMessageStore = useSavedMessagesStore();
const {show} = useAlert()

const loading = ref<boolean>(false);
const list = ref<IChat>();
const isFetching = ref<boolean>(false);
const paginationData = ref<IPaginationMeta>();
const historyModal = ref<boolean>(false);
const messageHistory = ref<IMessageHistory[]>([])

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL

const getErrors = async () => {
  if (isFetching.value) return

  try {
    isFetching.value = true
    list.value = await errorStore.getErrors(loading)
    if (list.value) {
      paginationData.value = {
        has_more: list.value.has_more,
        next_page: list.value.next_page,
        page_size: list.value.page_size,
        page: list.value.page,
        pages: list.value.pages,
        prev_page: list.value.prev_page,
        total: list.value.total,
      }
    }

  } finally {
    isFetching.value = false
  }
}

const handlePageChange = (page: number) => {
  errorStore.commonFilter.page = page;
}

const handleLimitChange = (limit: number) => {
  errorStore.commonFilter.page = 1;
  errorStore.commonFilter.page_size = limit;
}

const formatDate = (value: string): string => {
  return DateTime.fromFormat(value, 'yyyy-MM-dd HH:mm:ss', {
    zone: 'utc',
  })
      .setZone('America/New_York')
      .toFormat('MMM d - HH:mm')
}

const imageClick = (item: any, event: any) => {
  event.stopPropagation()
  window.open(`${apiBaseUrl}${item.media_path}`, "_blank");
}

const closeModal = () => {
  messageHistory.value = []
}

const showHistoryModal = (history: IMessageHistory[]) => {
  historyModal.value = true;
  messageHistory.value = history;
}

const closeHistoryModal = () => {
  historyModal.value = false;
  closeModal();
}

const saveMessage = async (item: IChatItem) => {
  let savedMessage: ISavedMessage = {
    item_type: item.item_type,
    is_saved: !item.is_saved,
    message_id: item.message_id,
    msg_id: item.msg_id,
    chat_id: item.chat_id,
    account_id: item.account_id,
    call_id: item.call_id
  }

  let data = await savedMessageStore.updateSavedMessage(loading, savedMessage)

  if (data) {
    show("Saved successfully", "success");
  }

  if (data) {
    appStore.triggerRefresh()
  }
}

const formatHistoryDate = (value: string) => {
  let newValue;
  if (value.includes("T")) {
    newValue = DateTime.fromISO(value, {
      zone: 'utc',
    })
        .setZone('America/New_York')
        .toFormat('yyyy-MM-dd HH:mm:ss')
  } else {
    newValue = DateTime.fromFormat(value, 'yyyy-MM-dd HH:mm:ss', {
      zone: 'utc',
    })
        .setZone('America/New_York')
        .toFormat('yyyy-MM-dd HH:mm:ss')
  }

  let time: string;

  time = newValue.split(" ")[1];

  return time.split(":")[0] + ":" + time.split(":")[1];
}

watch(
    [
      () => appStore.refreshKey,
      () => JSON.stringify(errorStore.commonFilter)
    ],
    () => {
      getErrors()
    },
    {immediate: true}
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ErrorPanel, {
        filter: _unref(errorStore).commonFilter
      }, null, 8, ["filter"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CommonFilter, {
          loading: loading.value,
          store: _unref(errorStore)
        }, null, 8, ["loading", "store"]),
        _createVNode(CommonTable, {
          striped: "",
          items: list.value?.items,
          loading: loading.value,
          headers: _unref(errorStore).headers
        }, {
          id: _withCtx(({index}) => [
            _createTextVNode(_toDisplayString((list.value.page - 1) * list.value.page_size + index + 1), 1)
          ]),
          activity_time: _withCtx(({item}) => [
            _createTextVNode(_toDisplayString(formatDate(item.activity_time)), 1)
          ]),
          reply_time_seconds: _withCtx(({item}) => [
            (item.reply_time_seconds)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(ReplyTime, {
                    time: item.reply_time_seconds
                  }, null, 8, ["time"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, " - "))
          ]),
          from: _withCtx(({item}) => [
            _createElementVNode("div", {
              class: _normalizeClass(["from_icon", item.is_outgoing ? 'outgoing' : ''])
            }, [
              (item.is_outgoing)
                ? (_openBlock(), _createBlock(_unref(ArrowNarrowUpRight), {
                    key: 0,
                    size: 16
                  }))
                : (_openBlock(), _createBlock(_unref(ArrowNarrowDownLeft), {
                    key: 1,
                    size: 16
                  }))
            ], 2)
          ]),
          text: _withCtx(({item}) => [
            _createElementVNode("div", _hoisted_5, [
              (item.is_deleted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_unref(Trash01), { size: 16 })
                  ]))
                : (item.reply_time_seconds && item.reply_time_seconds > 300)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_unref(Clock), { size: 16 })
                    ]))
                  : (item.is_edited && item.msg_type !== 'document')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_unref(Edit02), { size: 16 })
                      ]))
                    : _createCommentVNode("", true),
              (item.msg_type == 'photo')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "photo",
                      onClick: (e) => imageClick(item, e)
                    }, [
                      _createVNode(_unref(Image01), { size: 16 })
                    ], 8, _hoisted_10)
                  ]))
                : _createCommentVNode("", true),
              (item.msg_type == 'audio')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(VoiceMessage, {
                      "audio-url": `${_unref(apiBaseUrl)}${item.media_path}`
                    }, null, 8, ["audio-url"])
                  ]))
                : _createCommentVNode("", true),
              (item.msg_type == 'document')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(DocumentMessage, {
                      caption: item.caption,
                      "document-url": `${_unref(apiBaseUrl)}${item.media_path}`
                    }, null, 8, ["caption", "document-url"])
                  ]))
                : _createCommentVNode("", true),
              (item.msg_type == 'video')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(VideoMessage, {
                      "document-url": `${_unref(apiBaseUrl)}${item.media_path}`
                    }, null, 8, ["document-url"])
                  ]))
                : _createCommentVNode("", true),
              (item.item_type == 'call')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(CallMessage, { item: item }, null, 8, ["item"])
                  ]))
                : _createCommentVNode("", true),
              (item.is_edited && item.msg_type !== 'document')
                ? (_openBlock(), _createBlock(EditedMessage, {
                    key: 8,
                    onShowHistory: showHistoryModal,
                    history: item.history,
                    "last-text": item.text,
                    "last-time": item.activity_time,
                    "last-id": item.id
                  }, null, 8, ["history", "last-text", "last-time", "last-id"]))
                : (item.msg_type == 'text')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.text), 1))
                  : _createCommentVNode("", true)
            ])
          ]),
          save: _withCtx(({item}) => [
            _createElementVNode("div", {
              class: "save__icon",
              onClick: ($event: any) => (saveMessage(item))
            }, [
              (item.is_saved)
                ? (_openBlock(), _createBlock(_unref(Bookmark), {
                    key: 0,
                    class: "filled",
                    size: 16
                  }))
                : (_openBlock(), _createBlock(_unref(Bookmark), {
                    key: 1,
                    size: 16
                  }))
            ], 8, _hoisted_16)
          ]),
          _: 1
        }, 8, ["items", "loading", "headers"])
      ]),
      _createVNode(CommonPagination, {
        meta: paginationData.value,
        onChangePage: handlePageChange,
        onChangeLimit: handleLimitChange
      }, null, 8, ["meta"])
    ]),
    _createVNode(CommonModal, {
      modelValue: historyModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((historyModal).value = $event)),
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(CommonButton, {
            type: "primary",
            label: "Close",
            onClicked: closeHistoryModal
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageHistory.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "history__item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(formatHistoryDate(item.edited_at)), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(item.old_text), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})